<template>
	<div class="z-80 flex h-[60px] w-full items-center justify-between border-b border-[#E9EEF2] bg-white">
		<div class="flex min-w-0 items-center gap-4 px-6.5 max-md:gap-2 max-md:pr-0 max-md:pl-4">
			<Bars3Icon
				class="size-6 shrink-0 cursor-pointer text-won-dark-blue md:hidden"
				@click="toggleSidebar"
			/>
			<PanelLeftOpenIcon
				v-if="showCollapseToggle && collapsed"
				v-tooltip="{
					content: 'Toggle Sidebar <kbd>[</kbd>',
					html: true,
					placement: 'bottom',
					delay: { show: 500, hide: 100 },
				}"
				class="hidden size-5 cursor-pointer text-won-dark-blue md:block"
				@click="toggleSidebar"
			/>
			<PanelLeftCloseIcon
				v-else-if="showCollapseToggle"
				v-tooltip="{
					content: 'Toggle Sidebar <kbd>[</kbd>',
					html: true,
					placement: 'bottom',
					delay: { show: 500, hide: 100 },
				}"
				class="hidden size-5 cursor-pointer text-won-dark-blue md:block"
				@click="toggleSidebar"
			/>
			<router-link
				to="/"
				class="min-w-0"
			>
				<img
					class="h-8 w-auto max-w-full object-contain object-left max-md:h-7"
					:src="logoPath"
					alt="Wonsulting"
				/>
			</router-link>
			<template v-if="partnerStore.partner?.logo_url">
				<span class="mx-1 shrink-0 text-won-blue">|</span>
				<img
					class="h-8 w-auto max-w-full min-w-0 object-contain object-left max-md:h-7"
					:src="partnerStore.partner.logo_url"
					:alt="partnerStore.partner.name"
				/>
			</template>
		</div>
		<div class="flex shrink-0 items-center gap-4 px-6 max-md:gap-2 max-md:pr-4 max-md:pl-2">
			<InterviewAiOnboardingTrigger
				v-if="['interview-ai', 'interview-ai-interview'].includes(route.name)"
			/>
			<div
				v-if="route.name === 'auto-apply'"
				v-tooltip="{
					content: 'About AutoApply',
					placement: 'bottom',
					popperClass: 'max-w-[221px] text-center! text-[12px]! leading-[16px]! font-[Roboto] px-2 py-1'
				}"
				@click="handleDashboardOnboarding"
			>
				<auto-apply-tooltip />
			</div>
			<JourneyHeaderButton />
			<ActivitiesDropdown v-if="isAuthenticated()" />
		</div>
	</div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';

import { Bars3Icon } from '@heroicons/vue/24/outline';

import InterviewAiOnboardingTrigger from './interview-ai/interview-ai-onboarding-trigger.vue';
import ActivitiesDropdown from './activities/activities-dropdown.vue';
import JourneyHeaderButton from './your-journey/journey-header-button.vue';
import AutoApplyTooltip from '../icons/auto-apply-tooltip.vue';
import PanelLeftOpenIcon from '../icons/panel-left-open.vue';
import PanelLeftCloseIcon from '../icons/panel-left-close.vue';

import { setAuthState } from '../composables/auth';
import { useAutoApplyJobsStore } from '../store/auto-apply.store';
import { useSidebarStore } from '../store/sidebar.store';
import { usePartnerStore } from '../store/partner.store';

defineProps({
	showCollapseToggle: {
		type: Boolean,
		default: true,
	},
});

const sidebarStore = useSidebarStore();
const partnerStore = usePartnerStore();

const { collapsed } = storeToRefs(sidebarStore);
const { isAuthenticated } = setAuthState();
const route = useRoute();

const logoPath = '/img/logo.svg?id=36d75e6e63946874eae5';

const toggleSidebar = () => {
	sidebarStore.sidebarCollapseHandler();
};

const handleDashboardOnboarding = () => {
	const autoApplyStore = useAutoApplyJobsStore();
	autoApplyStore.setDashboardOnboarding(true);
};
</script>

